(() => {
  const scriptPromises = new Map();
  const scripts = {
    instagram: 'https://www.instagram.com/embed.js',
    tiktok: 'https://www.tiktok.com/embed.js',
    youtube: 'https://apis.google.com/js/platform.js'
  };

  const loadScript = (url) => {
    if (scriptPromises.has(url)) return scriptPromises.get(url);
    const promise = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = url;
      script.async = true;
      script.addEventListener('load', resolve, { once: true });
      script.addEventListener('error', reject, { once: true });
      document.head.append(script);
    });
    scriptPromises.set(url, promise);
    return promise;
  };

  const enhance = async (element) => {
    if (element.dataset.embedLoading) return;
    element.dataset.embedLoading = 'true';
    const provider = element.dataset.luminoSocialEmbed;
    let ready = false;
    const fallbackTimer = window.setTimeout(() => {
      if (!ready) element.dataset.embedUnavailable = 'true';
    }, 20000);
    const titleFrames = () => {
      element.querySelectorAll('iframe').forEach((frame) => {
        if (!frame.title) frame.title = element.dataset.embedTitle;
        const inlineHeight = frame.style.height.endsWith('px') ? Number.parseFloat(frame.style.height) : 0;
        const height = Math.max(frame.getBoundingClientRect().height, Number(frame.getAttribute('height')) || 0, inlineHeight);
        if (height > (provider === 'youtube' ? 24 : 180)) {
          ready = true;
          window.clearTimeout(fallbackTimer);
          delete element.dataset.embedUnavailable;
        }
      });
    };
    const observer = new MutationObserver(titleFrames);
    observer.observe(element, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'height'] });
    try {
      await loadScript(scripts[provider]);
      if (provider === 'instagram') window.instgrm?.Embeds?.process();
      if (provider === 'youtube') window.gapi?.ytsubscribe?.go(element);
      titleFrames();
    } catch {
      window.clearTimeout(fallbackTimer);
      element.dataset.embedUnavailable = 'true';
    }
  };

  const elements = document.querySelectorAll('[data-lumino-social-embed]');
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        enhance(entry.target);
      });
    }, { rootMargin: '200px 0px' });
    elements.forEach((element) => observer.observe(element));
  } else {
    elements.forEach(enhance);
  }
})();
